import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography, FormControl, Box, FormLabel, FormGroup, RadioGroup, Radio, FormControlLabel, Checkbox, InputLabel, Select, MenuItem, Input } from '@material-ui/core';
import FilterIcon from '@material-ui/icons/FilterList';
import { useSelector, useDispatch } from 'react-redux';
import { get, set, size } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { UserFilter } from 'global/utils/filter';
import { UserStatus, UserPermission } from 'global/lib/filter';
import { useScreen } from 'global/styles';
import useStyles from 'global/styles/filters';
import DiagContainer from 'global/components/diag-container';
import setUserRealm from 'redux/actions/userRealm';
import { sortAlphaNum } from 'global/utils';

export default function PerformTasksFilters({ display, vendors }) {
  const [showFilters, setShowFilters] = useState(false);
  const filter = useSelector((state) => get(state, `filter.users.manage`, UserFilter()));
  const authrealm = useSelector((state) => get(state, 'auth.realm'));
  const realmid = useSelector((state) => get(state, 'auth.realm.id'));
  const dispatch = useDispatch();
  const { status, permission } = filter; // realm_type,

  const { isMobile } = useScreen();

  const classes = useStyles({ isMobile });

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const foundInVendors = get(vendors, 'data', []).find((v) => `${v.clientId}` === `${get(authrealm, 'topRealm.id')}`);
    if (foundInVendors && get(filter, 'client_id') !== foundInVendors.id) {
      changeFilter(set({ ...filter }, 'client_id', foundInVendors.id));
    } else if (!!get(filter, 'client_id') && !authrealm) {
      changeFilter(set({ ...filter }, 'client_id', null));
    }
  }, [realmid, authrealm]);

  const changeFilter = (filt) => {
    dispatch(setFilter('users', 'manage', filt));
  };

  const handleStatusChange = (e) => {
    changeFilter(set({ ...filter }, `status`, e.target.value));
  };

  const handlePermissionChange = (name) => (e) => {
    const exists = permission.indexOf(name);
    const filt = { ...filter };
    if (exists !== -1) {
      filt.permission.splice(exists, 1);
    } else {
      filt.permission.push(name);
    }
    changeFilter(filt);
  };

  const handleClientChange = (e) => {
    const val = e.target.value;
    const vend = vendors.data.find((v) => v.id === val);
    dispatch(setUserRealm(get(vend, 'client')));
    changeFilter(set({ ...filter }, 'client_id', val));
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  return (
    <Box displayPrint="none">
      <div className={classes.grid}>
        {isMobile && (
          <Button aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" className={classes.icon} /> {showFilters ? 'Hide Filters' : 'Filters'}
          </Button>
        )}

        <DiagContainer useDialog={isMobile} onClose={toggleFilters} open={showFilters}>
          <Typography variant="overline">Filters</Typography>

          <form autoComplete="off" margin="normal" className={classes.form}>
            <Grid container>
              <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel component="legend">Status</FormLabel>
                    <RadioGroup size="small" value={status} onChange={(e) => handleStatusChange(e)}>
                      {UserStatus.map((ed, i) => (
                        <FormControlLabel key={i} control={<Radio />} label={ed.title} value={ed.value} />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid>

              <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel component="legend">Permission</FormLabel>
                    <FormGroup>
                      {UserPermission.map((ed, i) => (
                        <FormControlLabel key={i} control={<Checkbox checked={permission.indexOf(ed.value) > -1} onChange={handlePermissionChange(ed.value)} value={ed.value} />} label={ed.title} />
                      ))}
                    </FormGroup>
                  </FormControl>
                </div>
              </Grid>

              {size(vendors.data) > 0 && (
                <Grid item md={12} className={classes.formGrid}>
                  <div className={classes.flexFilters}>
                    <FormControl variant="standard" className={classes.formItem}>
                      <InputLabel htmlFor="Standard-scorecard-simple">Client</InputLabel>
                      <Select value={get(filter, 'client_id')} onChange={handleClientChange} input={<Input name="scorecard" id="Standard-scorecard-simple" />}>
                        <MenuItem value={0}>
                          <em>None</em>
                        </MenuItem>
                        {vendors.data
                          .sort((a, b) => sortAlphaNum(a, b, 'client.name'))
                          .map((vendor) => {
                            return (
                              <MenuItem key={vendor.id} value={vendor.id}>
                                {get(vendor, 'client.name')}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
              )}
            </Grid>
          </form>
        </DiagContainer>
      </div>
    </Box>
  );
}
